import { ChevronDown, ChevronUp, MoveDownIcon, User2Icon } from 'lucide-react';
import React, { useState } from 'react';

const DoctorCard = ({ setAvailTime,handleContinueToForm, setSelectedTime, doctor, setSelectedDoctor }) => {
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);

    const toggleAccordion = () => {
        setIsAccordionOpen(!isAccordionOpen);
        // setAvailTime(true);
    };

    return (
        <div className="card p-2 w-100" style={{ marginBottom: '10px', cursor: 'pointer' }}>
            <li className="people-item" onClick={toggleAccordion}>
                <div className="avatar text-success">
                    <User2Icon />
                </div>
                <div className="people-body">
                    <h6>
                        <span>{doctor?.first_name + " " + doctor?.last_name}</span>
                    </h6>
                    <span className='  '>{doctor?.profession}</span>
                    {/* <span>{doctor?.availableTimeSlots?.length} time slots</span> */}
                </div>
                <div>
                {
                isAccordionOpen ?
                <ChevronUp size={20} className=' text-success'/>
                :
                <ChevronDown size={20} className=' text-success'/>
                }
                </div>
            </li>
            {isAccordionOpen && (
                <div className="accordion-content w-100" style={{ marginTop: '10px', padding: '10px', border: '1px solid #ddd', borderRadius: '5px' }}>
                    <h6 className=' ' style={{paddingLeft:'30px'}}>Available Time Slots:</h6>
                    <ul className=' w-100 d-flex flex-wrap gap-2'>
                        {doctor?.availableTimeSlots?.length > 0 ? (
                            doctor.availableTimeSlots.map((item, index) => (
                                <div className=" " key={item.id}>
                                <button
                                    className={`btn w-100 border-success outline-success text-wrap 
                                       
                                    `}
                                    onClick={() => {
                                    // setSelectedDept(item);
                                    // setAvailTime(true);
                                    // setAvailDoc(null);
                                    setSelectedDoctor(doctor);
                                    setSelectedTime(item)
                                    handleContinueToForm();
                                    }}
                                >
                                    {item.formattedTime}
                                </button>
                                </div>
                            ))
                        ) : (
                            <li>No available time slots</li>
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default DoctorCard;